function configSettings($routeSegmentProvider) {
    const commonDetails = {
        template: require('../controllers/index.html'),
        controller: 'IndexIntegrationController as vm',
        untilResolved: {
            template: require('../../shared/loading-screen.html')
        },
        resolveFailed: {
            template: require('../../shared/loading-error.html')
        }
    };
    const segmentDetailsMerchant = {
        template: commonDetails.template,
        controller: commonDetails.controller,
        untilResolved: commonDetails.untilResolved,
        resolveFailed: commonDetails.resolveFailed,
        resolve: {
            merchantInfoData(merchantService) {
                'ngInject';
                return merchantService.loadMerchantInfo();
            },
            outletData() {
                'ngInject';
                return null;
            },
            outletsFeaturesInfo(merchantService, appConfig) {
                'ngInject';
                return merchantService.loadMerchantInfo()
                    .then(merchantResponse => {
                        return appConfig.isElevatedUser &&
                              merchantResponse.merchantPosProperties &&
                              merchantResponse.merchantPosProperties.posType ?
                              merchantService.getOutletsFeatures(merchantResponse) : Promise.resolve(true);
                    });
            },
            listOutlets(outletService) {
                'ngInject';
                return outletService.listOutlets();
            },
            listPosPartners(partnerService) {
                'ngInject';
                return partnerService.listPosPartners();
            }
        }
    };
    const segmentDetailsOutlet = {
        template: commonDetails.template,
        controller: commonDetails.controller,
        untilResolved: commonDetails.untilResolved,
        resolveFailed: commonDetails.resolveFailed,
        resolve: {
            outletData(outletService) {
                'ngInject';
                return outletService.loadOutlet();
            },
            merchantInfoData(merchantService) {
                'ngInject';
                return merchantService.loadMerchantInfo();
            },
            outletsFeaturesInfo() {
                'ngInject';
                return Promise.resolve(true);
            },
            listOutlets() {
                'ngInject';
                return Promise.resolve(true);
            },
            listPosPartners(partnerService) {
                'ngInject';
                return partnerService.listPosPartners();
            }
        }
    };
    $routeSegmentProvider
        .when('/merchant/settings/integration', 'integration_merchant_level')
        .when('/outlet/settings/integration', 'integration_outlet_level')
        .segment('integration_merchant_level', segmentDetailsMerchant)
        .segment('integration_outlet_level', segmentDetailsOutlet);
}
angular.module('qkr.integration.settings').config(configSettings);



// WEBPACK FOOTER //
// ./src/integration-settings/config/integration.settings.config.js